exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".selectedFile,.table tr:hover{background-color:#f1f7fd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/attachment/style/Attachment.css
// module id = 291
// module chunks = 1 2 3 4 5 7